// extracted by mini-css-extract-plugin
module.exports = {"playOnlineBtn":"PlayOnline_playOnlineBtn__2FNqR"};